import React, { useState, useEffect } from 'react';
import GAException from 'src/components/GAException';
import PropTypes from 'prop-types';
import {
  Box,
  CircularProgress,
  Typography,
  makeStyles
} from '@material-ui/core';
import { LogoBlue } from 'src/components/Logo';

// Definición de estilos usando Material-UI
const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    padding: theme.spacing(3),
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 2000
  },
  circularProgress: {
    color: theme.palette.spinner
  }
}));

/**
 * Componente que muestra una pantalla de carga (Splash Screen).
 * Se usa mientras se cargan datos esenciales antes de mostrar la app.
 * 
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.splashScreenMessage] - Mensaje opcional que se muestra en la pantalla de carga.
 */
function SplashScreen({ splashScreenMessage, ...rest }) {
  const classes = useStyles();
  const [logoSize, setLogoSize] = useState(200); // Tamaño inicial del logo

  useEffect(() => {

    // Función para ajustar el tamaño del logo en función del tamaño de la pantalla
    const updateLogoSize = () => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      // Ajustamos el tamaño en función del dispositivo
      let newSize;

      if (screenWidth < 600) {
        // Para móviles: basado en la altura
        newSize = Math.max(80, Math.min(150, screenHeight * 0.2));
      } else {
        // Para tablets y pantallas grandes: basado en el ancho
        newSize = Math.max(120, Math.min(200, screenWidth * 0.25));
      }

      setLogoSize(newSize);
    };

    updateLogoSize();
    window.addEventListener('resize', updateLogoSize);

    return () => {
      window.removeEventListener('resize', updateLogoSize);
    };
  }, []);

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="center">
        <LogoBlue style={{ width: logoSize, maxWidth: '100%' }} />
      </Box>
      {splashScreenMessage !== null && (
        <Box mt={4}>
          <Typography variant="h3" color="secondary">
            {splashScreenMessage}
          </Typography>
        </Box>
      )}
      <Box mt={6}>
        <CircularProgress className={classes.circularProgress} />
      </Box>
    </div>
  );
}

SplashScreen.propTypes = {
  splashScreenMessage: PropTypes.string,
};

SplashScreen.defaultProps = {
  splashScreenMessage: null,
};

export default SplashScreen;